<template>
    <div>
        <a class="search-form" href="/where-to-buy">
        <button class="btn-square dealer-btn" aria-label="Search">
            FIND MY DEALER &nbsp; &nbsp; <i class="icon icon-arrow"></i>
        </button>
        </a>
    </div>
</template>

<script>
import gmapsInit from "../utils/gmaps.js";

export default {
    props: {
        placeholder: String
    },
    name: "where-to-buy",
    data() {
        return {
            latitude: null,
            longitude: null,
            formattedAddress: null
        };
    },
    async mounted() {
        const google = await gmapsInit();
        window.autocomplete = new google.maps.places.Autocomplete(
            this.$refs.autocomplete,
            {
                componentRestrictions: {
                    country: window.culture.split("-")[1]
                },
                types: ['(regions)']
            }
        );

        autocomplete.addListener("place_changed", this.onPlaceChanged);
    },
    methods: {
        onPlaceChanged() {
            let place = autocomplete.getPlace();

            this.formattedAddress = place.formatted_address
            this.latitude = place.geometry.location.lat();
            this.longitude = place.geometry.location.lng();

        }
    }
};
</script>
<style scoped>
.dealer-btn{
    width: 170px;
}
.search-form{
    text-decoration: none;
}
</style>